import React from 'react';

// 基础角色头像路径
const AVATAR_IMAGES = {
  'char1': '/images/character-1.png',
  'char2': '/images/character-2.png',
  'char3': '/images/character-3.png',
  'char4': '/images/character-4.png',
  'char5': '/images/character-5.png',
};

// 🟢 [方案B] 头像保持干净：装备不再叠加在脸上，改由 <EquipmentLoadout /> 以「装备架」形式展示。
// inventory 仍作为 prop 保留以兼容调用方（此处不再用于叠加）。
const UserAvatar = ({ avatarId = 'char1', customAvatarUrl = null, inventory = [], size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-10 h-10',    // 40px
    md: 'w-24 h-24',    // 96px
    lg: 'w-40 h-40',    // 160px
    xl: 'w-64 h-64',    // 256px
  };

  const imgSrc = AVATAR_IMAGES[avatarId] || AVATAR_IMAGES['char1'];

  return (
    <div className={`relative rounded-full bg-white border-2 border-gray-200 shadow-sm overflow-hidden shrink-0 ${sizeClasses[size]} ${className}`}>
      <img
        src={customAvatarUrl || imgSrc}
        alt="Avatar"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default UserAvatar;
